/**
 * Extract airline's IATA/ICAO code and flight number from a flight identifier.
 * Port of split-flight-identifier.ts (Vue).
 */
export type SplitFlightIdentifier =
  | { iata: string; icao: undefined; flightNumber: number }
  | { iata: undefined; icao: string; flightNumber: number };

export function splitFlightIdentifier(flightIdentifier: string): SplitFlightIdentifier {
  const isIcao = /^[A-Za-z]{3}/.test(flightIdentifier);
  const splitAt = isIcao ? 3 : 2;
  const airlineCode = flightIdentifier.substring(0, splitAt);
  const flightNumber = Number.parseInt(flightIdentifier.substring(splitAt), 10);

  return isIcao
    ? { iata: undefined, icao: airlineCode, flightNumber }
    : { iata: airlineCode, icao: undefined, flightNumber };
}
